import { render, staticRenderFns } from "./WeightFieldOperatorPopover.vue?vue&type=template&id=0372343f&scoped=true&"
import script from "./WeightFieldOperatorPopover.vue?vue&type=script&lang=js&"
export * from "./WeightFieldOperatorPopover.vue?vue&type=script&lang=js&"
import style0 from "./WeightFieldOperatorPopover.vue?vue&type=style&index=0&id=0372343f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372343f",
  null
  
)

export default component.exports